import { ElementRef, Injectable } from "@angular/core";
import { Area } from "../../DataStructures/Area/Area";
import { Trip } from "../../DataStructures/Trip/Trip";
import { QuickDialog } from "../Dialog/QuickDialog";
import * as moment from 'moment';
import { MatDialog } from "@angular/material";
import { RunConfig } from "../../DataStructures/RunConfiguration/RunConfig";
import { TripColorMap } from "../TripColorMap/TripColorMap";
import { MainService } from "../../services/optimizer-service/optimizer.service";
import { AreaMarker } from "./AreaMarker";
import { Week } from "../../DataStructures/Week/Week";
import { QuickAssignment } from "../VehicleAllocation/QuickAssignment";
import { VehicleScheduler } from "../Scheduling/VehicleScheduler";
import { ChildInitOptions, OptimzerComponent } from "../../admin-dashboard/optimizer/optimzer.component";
import { VehicleService } from "../../services/vehicle-service/vehicle.service";
import { Vehicle } from "../../DataStructures/Vehicle/Vehicle";
import { State } from "../../DataStructures/State/State";
import { CONSTANTS } from "../Constants";
import { CustomInfoWindow } from "../CustomInfoWindow/CustomInfoWindow";
import { SimpleDriverWindow } from "../SimpleDriverWindow/SimpleDriverWindow";
declare var google: any;

@Injectable()
export class MapControls {
    multi = false;
    week: Week;
    map: any;
    directionsDisplay: any;
    mapReference: any;
    markers = [];
    shownTrips: Array<Trip> = [];
    tripMarkers = [];
    maxShow = 6;
    runConfig: RunConfig;
    scheduler: VehicleScheduler;
    areaMarkers = new Array<AreaMarker>();
    locationMap = {

    }
    editMode = false;
    editType = "swap";
    sourceTrip: Trip = null;
    sourceAreas: Array<Area> = [];
    optimizerRef: OptimzerComponent;

    constructor(
        public optimizerService: MainService,
        private vehicleService: VehicleService,
        private dialog: MatDialog,
        private assignVehicle: QuickAssignment) {
    }

    setWeek(week: Week) {
        this.week = week;
    }

    initialize(mapReference: ElementRef) {
        this.mapReference = mapReference;
    }

    setRunConfig(runConfig: RunConfig) {
        this.runConfig = runConfig;
    }

    setScheduler(scheduler: VehicleScheduler) {
        this.scheduler = scheduler;
    }

    setOptimizerRef(ref: OptimzerComponent) {
        this.optimizerRef = ref;
    }

    getUserLocation() {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const latitude = position.coords.latitude;
                        const longitude = position.coords.longitude;
                        resolve({ latitude, longitude });
                    },
                    (error) => {
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                reject("User denied the request for Geolocation.");
                                break;
                            case error.POSITION_UNAVAILABLE:
                                reject("Location information is unavailable.");
                                break;
                            case error.TIMEOUT:
                                reject("The request to get user location timed out.");
                                break;
                            default:
                                reject("An unknown error occurred.");
                                break;
                        }
                    }
                );
            } else {
                reject("Geolocation is not supported by this browser.");
            }
        });
    }



    centerMapOnCurrentPosition() {

        this.getCurrentPosition((pos) => {
            this.centerMapOnLoaction(pos);
        })
    }

    drawPolylineForTrip(trip: Trip) {

        var coords = [];

        trip.areas.forEach(a => {

            var coord = a.getLatLng();
            console.log(coord);
            coords.push(coord);
        });

        var tripHighlight = new google.maps.Polyline({
            path: coords,
            geodesic: true,
            strokeColor: '#FF0000',
            strokeOpacity: 1.0,
            strokeWeight: 2
        });

        tripHighlight.setMap(this.map);
    }

    createMapAndCenterOnLoaction(lat, lng, disableDefaultUI = false, fullscreenControl = false, mapStyles = []) {

        var mapCenter = new google.maps.LatLng(lat, lng);

        var options = null;



        options = {
            center: mapCenter,
            zoom: 13,
            styles: mapStyles,
            disableDefaultUI: disableDefaultUI,
            fullscreenControl: fullscreenControl,
            mapTypeControl: false/*,
            mapTypeId: 'satellite'*/
        }
        this.map = new google.maps.Map(this.mapReference.nativeElement,
            options);
        this.directionsDisplay = new google.maps.DirectionsRenderer({ suppressMarkers: true });
        this.directionsDisplay.setMap(this.map);
    }

    getCurrentPosition(func) {

        let pos = null;
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                func(pos);
            })
        } else {
            return;
        }
    }

    centerMapOnLoaction(position, zoom = 15) {

        this.map.setCenter(position);
        this.map.setZoom(zoom);
    }

    registerAutcompleteListener(event: string, autocomplete): Promise<any> {
        return new Promise((resolve, reject) => {
            autocomplete.addListener(event, () => {
                var place = autocomplete.getPlace();
                resolve(place);
            });
        })
    }

    registerListener(event: string): Promise<any> {

        return new Promise((resolve, reject) => {
            this.map.addListener(event, (e) => {

                resolve(e);
            });
        })
    }

    replaceMarkerImage(areas: Array<Area>, image: string) {
        console.log(image);
        this.removeMarkers(areas);
        this.addMarkersForAreas(areas, image);
    }

    removeMarkers(areas: Array<Area>) {
        var areaMarkers = this.areaMarkers.filter(x => areas.find(y => y.userid == x.areaid) != null);
        var rawMarkers = [];
        areaMarkers.forEach(am => {
            rawMarkers.push(am.marker);
        })
        this.clearMarkers(rawMarkers);
    }

    addTripMarker(marker, label, icon) {
        this.markers.push(marker);
        return marker;
    }


    openInfoWindow(msg, marker) {

        var infowindow = new google.maps.InfoWindow({
            content: msg
        });

        infowindow.open(this.map, marker);
    }

    clearMarkers(markersArray: Array<any> = null) {

        if (markersArray != null) {
            for (var i = 0; i < markersArray.length; i++) {
                markersArray[i].setMap(null);
            }
            markersArray.length = 0;
            return markersArray;
        } else {
            for (var i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null);
            }
            this.markers.length = 0;
            return this.markers;
        }
    }

    addSimpleDriverMarker(location, driver) {
        var marker = null;
        var contentString = SimpleDriverWindow.getWindowContent(driver);
        marker = new google.maps.Marker({
            position: location,
            label: "",
            map: this.map,
            icon: {
                url: '../../assets/busmarker.png',
                scaledSize: new google.maps.Size(30, 30),
            }
        });
        const infowindow = new SimpleDriverWindow(this.map, location, contentString);
        this.markers.push(marker);
        infowindow.setMap(this.map);
        return {
            marker: marker,
            infowindow: infowindow
        };
    }

    addDriverMarker(location, driver) {
        var marker = null;
        var contentString = CustomInfoWindow.getWindowContent(driver);
        marker = new google.maps.Marker({
            position: location,
            label: "",
            map: this.map,
            icon: CustomInfoWindow.getDriverMarkerIcon(driver),
            title: `${driver.firstname || ''} ${driver.lastname || ''}`.trim()
        });
        const infowindow = new CustomInfoWindow(this.map, location, contentString);
        this.markers.push(marker);
        infowindow.setMap(this.map);
        marker.addListener('click', () => infowindow.toggle());
        return {
            marker: marker,
            infowindow: infowindow
        };
    }


    addMarker(location, label, clearPrevious = false, icon = null) {

        clearPrevious ? this.clearMarkers() : null;
        var marker = null;
        if (!icon) {
            marker = new google.maps.Marker({
                //animation: google.maps.Animation.DROP,
                position: location,
                label: label,
                map: this.map
            });
        } else {
            marker = new google.maps.Marker({
                position: location,
                label: label,
                map: this.map,
                icon: typeof icon === 'string' ? '../../assets/' + icon : icon
            });
        }
        this.markers.push(marker);
        return marker;
    }




    //When set to true we show multiple trips
    setMultiTripState(multi: boolean) {
        this.clearMarkers();
        if (multi) {
            this.directionsDisplay.setMap(null);
        } else {
            this.directionsDisplay.setMap(this.map);
        }
        this.multi = multi;
    }


    addMarkersForTrip(trip: Trip, clickListener = null): Array<any> {
        ;
        this.locationMap = {};
        var key = null;
        var m = null;
        var icon = null;
        var label = null;
        var counter = 1;
        var addedMarkers = [];
        trip.areas.forEach(a => {
            icon = {
                url: `../../assets/${trip.markerPng}`,
                size: new google.maps.Size(50, 50),
                origin: new google.maps.Point(0, 0),
                scaledSize: new google.maps.Size(50, 50),
                labelOrigin: new google.maps.Point(25, 18.5)
            }
            label = {
                text: "",
                color: 'black',
                fontSize: '15px',
                fontWeight: 'bold'
            };
            m = a.getLatLng();

            //This block of code looks confusing but it prevents duplicate markers on the map
            key = a.getLatLngKey();
            if (this.locationMap[key]) {
                this.locationMap[key].notation = [this.locationMap[key].notation[0], counter];;
                label.text = `${this.locationMap[key].notation[0]}-${this.locationMap[key].notation[1]}`;
                var marker = new google.maps.Marker({
                    position: m,
                    label: label,
                    map: this.map,
                    icon: icon
                });
                this.locationMap[key].marker.setMap(null);
                this.locationMap[key].marker = marker;
            } else {
                label.text = counter + "";
                var marker = new google.maps.Marker({
                    position: m,
                    label: label,
                    map: this.map,
                    icon: icon
                });
                this.locationMap[key] = {
                    notation: [counter],
                    marker: marker
                }
            }
            this.markers.push(marker);
            addedMarkers.push(marker);
            marker.addListener('click', (e) => {
                clickListener(this, this.map, marker, trip, a);
            });
            counter += 1;
        });
        return addedMarkers;
    }

    addMarkersForAreas(areas: Array<Area>, icon = null): Array<any> {

        var markers = [];
        var addedMarkers = [];
        var mapIcon = icon ? icon : "usermarker.png";
        areas.forEach(a => {
            var marker = a.getLatLng();
            //markers.push(a.getLatLng());
            var addedMarker = this.addMarker(marker, "", false, mapIcon);
            addedMarker.addListener('click', () => { this.openInfoWindow("Adress:" + a.address + "| Name: " + a.destinations[0].person, addedMarker) });
            this.areaMarkers.push(new AreaMarker(a.userid, addedMarker));
            addedMarkers.push(marker);
        });
        /*markers.forEach(m =>{
            var m = this.addMarker(m,"",false,"usermarker.png");
            addedMarkers.push(m);
        })*/
        return addedMarkers;
    }


    showRoundTripTime(roundTripTime, marker) {

        var infowindow = new google.maps.InfoWindow({
            content: "Back To base in " + roundTripTime + " minutes"
        });

        infowindow.open(this.map, marker);
    }


    addDirectionsMarkers(trip: Trip, runConfig: RunConfig) {

        var markers = [];
        var counter = trip.pickupType == CONSTANTS.PICKUP_TYPE_HOME ? 0 : 1;

        if (trip.currentLegIndex == 1) {
            counter = 24;
        }

        var legs: Array<any> = trip.legs[trip.currentLegIndex].routes[0].legs;
        /*var areas = [];
        areas.push(trip.source);
        trip.areas.forEach(a => {
            areas.push(a);
        })*/
        legs.forEach(leg => {
            if (trip.pickupType == CONSTANTS.PICKUP_TYPE_HOME && legs.indexOf(leg) != 0) {
                var marker = this.addMarker(leg.start_location, counter.toString());
                marker.address = leg.address;
                marker.trip = trip;
                marker.index = trip.pickupType == CONSTANTS.PICKUP_TYPE_HOME ? (counter + 1) : counter;
                marker.addListener('click', () => { this.openMapWindowDialog(trip, marker.index - 2, runConfig) });
                markers.push(marker);
            } else if (trip.pickupType != CONSTANTS.PICKUP_TYPE_HOME) {
                var marker = this.addMarker(leg.start_location, counter.toString());
                marker.address = leg.address;
                marker.trip = trip;
                marker.index = counter;
                marker.addListener('click', () => { this.openMapWindowDialog(trip, marker.index - 2, runConfig) });
                markers.push(marker);
            }
            counter++;
        });
        if (trip.pickupType == CONSTANTS.PICKUP_TYPE_HOME && !trip.isBasicTrip()) {
            var location = new google.maps.LatLng(trip.destination.destinations[0].lat, trip.destination.destinations[0].lng)
            var marker = this.addMarker(location, null, false, 'pickup_small.png');
            marker.address = trip.destination.address;
            marker.trip = trip;
            marker.index = trip.pickupType == CONSTANTS.PICKUP_TYPE_HOME ? (counter + 1) : counter;
            markers.push(marker);
        }
        if (trip.pickupType == CONSTANTS.PICKUP_TYPE_WORK) {
            var location = new google.maps.LatLng(trip.destination.destinations[0].lat, trip.destination.destinations[0].lng)
            var marker = this.addMarker(location, null, false, 'pickup_small.png');
            marker.address = trip.destination.address;
            marker.trip = trip;
            marker.index = trip.pickupType == CONSTANTS.PICKUP_TYPE_WORK ? (counter + 1) : counter;
            markers.push(marker);
        }


        return markers;
    }


    openMarkerOptionsDialog(trip: Trip, areas: Array<Area>) {
        new QuickDialog(this.dialog).MarkerOptionsDialog({
            trip: trip,
            week: this.week,
            areas: areas,
            controls: this
        }).then(async (data: { action: string, trip: Trip, areas: Array<Area>, newPos: any }) => {
            if (data) {
                if (data.action == 'new') {
                    this.createPassengersInNewTrip(trip, areas);
                }
                if (data.action == 'update') {
                    var stateBeforeUpdate = data.trip.areas.map(x => Area.copy(x));
                    if (data.trip.areas.indexOf(data.areas[0]) == (data.newPos - 1)) {
                        new QuickDialog(this.dialog).InfoDialog(`Passenger is already at position ${data.newPos}`, "Invalid Position", "OK");
                        return;
                    }
                    if ((data.newPos) < 1 || (data.newPos) > (data.trip.areas.length)) {
                        new QuickDialog(this.dialog).InfoDialog(`Number can't be less than 1 or greater than ${(data.trip.areas.length)} for this trip!`, "Invalid Position", "OK");
                        return;
                    }
                    var copy = this.week.copy();
                    data.trip.updatePosition(data.areas, data.newPos);

                    try {
                        var result = await VehicleScheduler.handleTripTimeChange(
                            this.week,
                            data.trip, stateBeforeUpdate, this.optimizerService, this.runConfig, this.vehicleService, this.dialog);
                        var initOptions: ChildInitOptions = {
                            tripSummary: {
                                stopClear: false,
                                selectedDay: this.optimizerRef.tripSummary.selectedDay.getDayString(),
                                selectedHour: this.optimizerRef.tripSummary.selectedHour.getTimeString()
                            }
                        };
                        try {
                            await this.optimizerService.updateTrip(data.trip);
                        } catch (e) {
                            console.log(e);
                        }
                        this.saveState(copy);
                        this.optimizerRef.initializeChildren(this.week, initOptions);
                    } catch (e) {
                        alert(e);
                    }
                    this.clearTripMarkers(data.trip);
                    this.addTripMarkers(data.trip, false, false);
                }
            }
        });
    }

    async createPassengersInNewTrip(sourceTrip: Trip, areas: Array<Area>) {
        if (sourceTrip.areas.length <= 1) {
            new QuickDialog(this.dialog).InfoDialog(`You can't create a new trip with this passenger as they are already the only passenger in this trip.`, `Single Passenger`, "OK");
            return;
        }
        var d = new QuickDialog(this.dialog).LoadingDialog("Creating New Trip..");
        try {
            var copy = this.week.copy();
            var p = sourceTrip.removePassengers(areas);
            var newTrip: Trip = null;
            if (sourceTrip.pickupType == CONSTANTS.PICKUP_TYPE_HOME) {
                var newTrip = new Trip(p[0], sourceTrip.destination, p, sourceTrip.pickupType);
            } else {
                var newTrip = new Trip(sourceTrip.source, sourceTrip.destination, p, sourceTrip.pickupType);
            }
            await newTrip.calculateDirections(this.optimizerService);
            await this.optimizerService.createTripInTimeSlot(sourceTrip.slotid, newTrip);
            await newTrip.reload(this.optimizerService);
            var localDateString = moment(newTrip.slotTime).toDate().toString();
            //var trips = await this.assignVehicle.assignVehiclesToTrips(this.runConfig, [newTrip], localDateString, this.scheduler);
            //newTrip = trips[0];
            await sourceTrip.calculateDirections(this.optimizerService);
            try {
                await this.optimizerService.updateTrip(sourceTrip);
            } catch (e) {
                console.log(e);
            }

            //this.scheduler.computeSchedule(trips);
            var day = this.week.getDayForTrip(sourceTrip);
            day.optimizationResults.push(newTrip);

            this.clearTripMarkers(sourceTrip)
            this.addTripMarkers(sourceTrip, false, false);
            this.disableEditMode();
            this.saveState(copy);
            var initOptions: ChildInitOptions = {
                tripSummary: {
                    stopClear: false,
                    selectedDay: this.optimizerRef.tripSummary.selectedDay.getDayString(),
                    selectedHour: this.optimizerRef.tripSummary.selectedHour.getTimeString()
                }
            };
            this.optimizerRef.initializeChildren(this.week, initOptions);
            d.close();
        } catch (e) {
            d.close();
            throw new Error(e);
        }
    }



    openMapWindowDialog(trip: Trip, index: number, runConfig: RunConfig) {

        new QuickDialog(this.dialog).MapMarkerDialog({ trip: trip, index: index, runConfig }).then((data) => {

        });
    }

    addTripMarkers(trip: Trip, updateColor = true, center = true) {
        if (updateColor) {
            var color = null;
            var usedColors = this.getUsedColors();
            for (var i = 0; i < TripColorMap.colors.length; i++) {
                if (!usedColors.includes(TripColorMap.colors[i])) {
                    usedColors.push(TripColorMap.colors[i]);
                    color = TripColorMap.colors[i];
                    break;
                }
            }
            var count = this.shownTrips.length;
            if (count == this.maxShow) {
                return;
            }
            trip.color = color;
            trip.markerPng = `usermarker_${color}.png`;
        }
        var markers = this.addMarkersForTrip(trip, this.onMarkerClick);
        this.tripMarkers[trip.id] = markers;
        this.shownTrips.push(trip);
        if (center) {
            this.centerMapOnLoaction(trip.areas[0].getLatLng(), 12);
        }
    }

    getUsedColors() {
        var colors = [];
        this.shownTrips.forEach(t => {
            colors.push(t.color);
        });
        return colors;
    }

    async onMarkerClick(controls: MapControls, map, marker, trip: Trip, area: Area) {

        if (controls.editMode) {
            if (controls.editType == 'swap') {
                var areas = trip.getAreasByKey(area.getLatLngKey());
                await controls.swap(areas);
            } else if (controls.editType == 'add') {
                controls.add(trip, area);
            }
            controls.clearTripMarkers(trip);
            controls.addTripMarkers(trip, false, false);
        } else {
            var passengersAtArea = trip.getAreasByKey(area.getLatLngKey());
            controls.openMarkerOptionsDialog(trip, passengersAtArea);
        }
    }


    async performAdd(targetTrip: Trip, targetArea: Area, initOptions: ChildInitOptions) {
        if (targetTrip == this.sourceTrip) {
            new QuickDialog(this.dialog).InfoDialog("Can't add to the same trip, Please click on another trip", "Invalid trip", "OK");
            this.disableEditMode();
            return;
        }

        var targetState = targetTrip.areas.map(x => Area.copy(x));
        var sourceSate = this.sourceTrip.areas.map(x => Area.copy(x));

        //Insert at index in target trip
        var pesonsAtLocation = targetTrip.getAreasByKey(targetArea.getLatLngKey());
        var indexToAddTo = targetTrip.areas.indexOf(pesonsAtLocation[0]);
        await targetTrip.addPassengerAtIndex(this.sourceAreas, indexToAddTo);

        //Remove from source trip
        var day = this.week.getDayForTrip(this.sourceTrip);
        this.sourceTrip.removePassengers(this.sourceAreas);
        try {
            var choice = await VehicleScheduler.handleTripTimeChange(
                this.week, targetTrip, targetState, this.optimizerService, this.runConfig, this.vehicleService, this.dialog);
            if (choice.choice == 'cancel') {
                this.sourceTrip.areas = sourceSate;
                this.clearTripMarkers(targetTrip);
                this.addTripMarkers(targetTrip, false, false);
                this.clearTripMarkers(this.sourceTrip);
                this.addTripMarkers(this.sourceTrip, false, false);
                this.disableEditMode();
                return;
            }

            if (this.sourceTrip.areas.length > 0) {

                await VehicleScheduler.handleTripTimeChange(
                    this.week, this.sourceTrip, sourceSate, this.optimizerService, this.runConfig, this.vehicleService, this.dialog);
            }
        } catch (e) {
            alert(e);
        }
        if (this.sourceTrip.areas.length == 0) {
            day.removeTrip(this.sourceTrip);
            try {
                await this.optimizerService.deleteTrip(this.sourceTrip.id);
            } catch (e) {
                console.log(e);
            }
            this.optimizerRef.initializeChildren(this.week, initOptions);
        }
        this.clearTripMarkers(targetTrip);
        this.addTripMarkers(targetTrip, false, false);
        this.clearTripMarkers(this.sourceTrip);
        this.addTripMarkers(this.sourceTrip, false, false);
        try {
            await this.optimizerService.updateTrip(this.sourceTrip);
        } catch (e) {
            console.log(e);
        }
        this.disableEditMode();
    }

    async add(targetTrip: Trip, targetArea: Area) {
        //Then initialize
        var initOptions: ChildInitOptions = {
            tripSummary: {
                stopClear: true,
                selectedDay: this.optimizerRef.tripSummary.selectedDay.getDayString(),
                selectedHour: this.optimizerRef.tripSummary.selectedHour.getTimeString()
            }
        };
        try {
            var copy = this.week.copy();
            await this.performAdd(targetTrip, targetArea, initOptions);
            try {
                await this.optimizerService.updateTrip(targetTrip);
            } catch (e) {
                console.log(e);
            }
            this.saveState(copy);
        } catch (e) {
            if (e == 'MAX_CAPACITY') {
                var currentCapacity = targetTrip.vehicleReservation.vehicle.capacity;
                var newType = await this.vehicleService.getNextVehicleIncrement(currentCapacity);
                if (!newType) {
                    new QuickDialog(this.dialog).InfoDialog(`${currentCapacity} is the largest vehicle size, therefore you can't add anymore passengers to this trip`, `Max Capacity Reached`, "OK");
                    return;
                }
                new QuickDialog(this.dialog).VehicleSizeDialog(targetTrip, newType.capacity).then(async (choice) => {
                    if (choice == 'upgrade') {
                        if (Vehicle.isContracted(targetTrip.getVehicle())) {
                            targetTrip.upgradeContractVehicleSize(newType.capacity);
                            await this.performAdd(targetTrip, targetArea, initOptions);
                            try {
                                await this.optimizerService.updateTrip(this.sourceTrip);
                            } catch (e) {
                                console.log(e);
                            }
                            try {
                                await this.optimizerService.updateTrip(targetTrip);
                            } catch (e) {
                                console.log(e);
                            }
                            this.saveState(copy);
                            this.optimizerRef.initializeChildren(this.week, initOptions);
                        } else {
                            //TODO: Handle scenario where vehicle type is not contracted.
                        }
                    }
                    if (choice == 'new') {
                        await this.createPassengersInNewTrip(this.sourceTrip, this.sourceAreas);
                        this.saveState(copy);
                        this.optimizerRef.initializeChildren(this.week, initOptions);
                    }
                    if (choice == 'cancel') {
                        this.disableEditMode();
                    }
                });
            } else {
                this.disableEditMode();
            }
        }
    }

    enableEditMode(trip: Trip, areas: Array<Area>, type = "swap") {
        this.editMode = true;
        this.editType = type;
        this.sourceTrip = trip;
        this.sourceAreas = areas;
    }

    disableEditMode() {
        this.editMode = false;
        this.sourceTrip = null
        this.sourceAreas = [];
    }

    saveState(copy: Week) {
        var state = new State(copy);
        state.setMetadata<Array<string>>("selectedTrips", this.shownTrips.map(x => { return x.id }));
        //Add the previous state of the week before the change
        this.optimizerRef.addState(state, new State(this.week));
    }


    async swap(targetAreas: Array<Area>) {
        if (this.sourceAreas && this.sourceTrip) {

            if (!this.sourceTrip.areas.find(x => x == targetAreas[0])) {
                new QuickDialog(this.dialog).InfoDialog("Can't swap between two different trips, try moving the passenger to the trip instead", "Invalid Swap", "OK");
                this.disableEditMode();
                return;
            }

            var stateBeforeSwap = this.sourceTrip.areas.map(x => Area.copy(x));
            var copy = this.week.copy();
            //Then initialize
            var initOptions: ChildInitOptions = {
                tripSummary: {
                    stopClear: false,
                    selectedDay: this.optimizerRef.tripSummary.selectedDay.getDayString(),
                    selectedHour: this.optimizerRef.tripSummary.selectedHour.getTimeString(),
                }
            };
            this.sourceTrip.swap(this.sourceAreas, targetAreas);
            try {
                var result = await VehicleScheduler.handleTripTimeChange(
                    this.week,
                    this.sourceTrip,
                    stateBeforeSwap,
                    this.optimizerService,
                    this.runConfig,
                    this.vehicleService,
                    this.dialog
                );
                this.saveState(copy);
                try {
                    await this.optimizerService.updateTrip(this.sourceTrip);
                } catch (e) {
                    console.log(e);
                }
                this.optimizerRef.initializeChildren(this.week, initOptions);
            } catch (e) {
                console.log(e);
                alert(e);
            }
            this.disableEditMode();
        }
    }

    getAffectedTrips() {

    }

    clearTripMarkers(trip: Trip) {
        if (this.tripMarkers[trip.id]) {
            this.tripMarkers[trip.id].forEach(m => {
                m.setMap(null);
            });
        }
        var index = this.shownTrips.indexOf(trip);
        if (index > -1) {
            this.shownTrips.splice(index, 1);
        }
    }

    resetShownTrips() {
        this.shownTrips = [];
    }
}
